(() => {
  if (window.__tanReelLightboxReady) return;
  window.__tanReelLightboxReady = true;

  const style = document.createElement('style');
  style.textContent = [
    '.tan-reel-expand{position:absolute;z-index:5;right:12px;bottom:12px;display:grid;place-items:center;width:40px;height:40px;padding:0;border:1px solid rgba(255,255,255,.72);border-radius:9px;background:rgba(255,255,255,.9);color:#0b0714;box-shadow:0 10px 28px rgba(5,2,12,.2);backdrop-filter:blur(8px);cursor:pointer;transition:transform .18s ease,background .18s ease,opacity .18s ease}',
    '.tan-reel-expand:hover{transform:scale(1.05);background:#fff}',
    '.tan-reel-expand:focus-visible{outline:3px solid #2ed9cf;outline-offset:3px}',
    '.tan-reel-expand svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}',
    '.tan-story-card__media--video .tan-story-card__content{right:66px}',
    '.tan-proof-short__media--video .tan-proof-short__content{right:62px}',
    '.tan-reel-lightbox[hidden]{display:none!important}',
    '.tan-reel-lightbox{position:fixed;z-index:2147483000;inset:0;display:grid;place-items:center;padding:16px;background:rgba(4,3,8,.88);backdrop-filter:blur(8px)}',
    '.tan-reel-lightbox__stage{display:flex;align-items:center;justify-content:center;width:100%;height:100%;min-width:0;min-height:0}',
    '.tan-reel-lightbox__video{display:block!important;width:auto!important;height:auto!important;max-width:min(94vw,760px)!important;max-height:calc(100dvh - 32px)!important;object-fit:contain!important;transform:none!important;transition:none!important;border-radius:14px;background:#050505;box-shadow:0 24px 80px rgba(0,0,0,.46)}',
    '.tan-reel-lightbox__close{position:fixed;z-index:2;top:max(14px,env(safe-area-inset-top));right:max(14px,env(safe-area-inset-right));display:grid;place-items:center;width:48px;height:48px;padding:0;border:1px solid rgba(255,255,255,.62);border-radius:50%;background:rgba(255,255,255,.94);color:#0b0714;box-shadow:0 12px 34px rgba(0,0,0,.28);font:400 36px/1 Arial,sans-serif;cursor:pointer}',
    '.tan-reel-lightbox__close:hover{background:#fff;transform:scale(1.04)}',
    '.tan-reel-lightbox__close:focus-visible{outline:3px solid #2ed9cf;outline-offset:3px}',
    'body.tan-reel-lightbox-open{overflow:hidden!important}',
    '@media(max-width:749px){.tan-reel-expand{right:10px;bottom:10px;width:36px;height:36px;border-radius:8px}.tan-reel-expand svg{width:20px;height:20px}.tan-story-card__media--video .tan-story-card__content,.tan-proof-short__media--video .tan-proof-short__content{right:54px}.tan-reel-lightbox{padding:8px}.tan-reel-lightbox__video{max-width:100vw!important;max-height:100dvh!important;border-radius:0}.tan-reel-lightbox__close{width:44px;height:44px;font-size:32px}}'
  ].join('');

  (document.head || document.documentElement).appendChild(style);

  let lightbox;
  let stage;
  let closeButton;
  let activeState;

  const setOriginButtonState = (state, playing) => {
    const button = state?.media?.querySelector('[data-story-play], [data-proof-play]');
    if (!button) return;
    button.hidden = false;
    button.classList.toggle('is-playing', playing);
    button.setAttribute('aria-pressed', String(playing));
    const nextLabel = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
    if (nextLabel) button.setAttribute('aria-label', nextLabel);
    const icon = button.querySelector('[data-proof-play-icon], span');
    if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
  };

  const emitState = (state) => {
    if (!state?.media || !state.video) return;
    const playing = !state.video.paused && !state.video.ended;
    setOriginButtonState(state, playing);
    state.media.dispatchEvent(new CustomEvent('tan:reel-video-state', {
      bubbles: true,
      detail: { video: state.video, playing }
    }));
  };

  const ensureLightbox = (trigger) => {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'tan-reel-lightbox';
      lightbox.hidden = true;
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.innerHTML = '<div class="tan-reel-lightbox__stage"></div><button class="tan-reel-lightbox__close" type="button">×</button>';
      document.body.appendChild(lightbox);
      stage = lightbox.querySelector('.tan-reel-lightbox__stage');
      closeButton = lightbox.querySelector('.tan-reel-lightbox__close');
      closeButton.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox || event.target === stage) closeLightbox();
      });
    }

    const dialogLabel = trigger?.dataset.reelDialogLabel;
    const closeLabel = trigger?.dataset.reelCloseLabel;
    if (dialogLabel) lightbox.setAttribute('aria-label', dialogLabel);
    if (closeLabel) closeButton.setAttribute('aria-label', closeLabel);
  };

  const removeVideoListeners = (state) => {
    if (!state) return;
    state.video.removeEventListener('playing', state.onStateChange);
    state.video.removeEventListener('pause', state.onStateChange);
    state.video.removeEventListener('ended', state.onStateChange);
  };

  function closeLightbox() {
    const state = activeState;
    if (!state) return;
    removeVideoListeners(state);

    if (state.placeholder.parentNode) {
      state.placeholder.parentNode.insertBefore(state.video, state.placeholder);
      state.placeholder.remove();
    }

    state.video.controls = state.previousControls;
    state.video.preload = state.previousPreload;
    state.video.classList.remove('tan-reel-lightbox__video');
    emitState(state);

    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tan-reel-lightbox-open');
    document.body.style.overflow = state.previousBodyOverflow;
    activeState = undefined;

    if (state.trigger?.isConnected && state.trigger.tabIndex >= 0) {
      state.trigger.focus({ preventScroll: true });
    }
  }

  const hydrateVideo = (video) => {
    const lazySources = video.querySelectorAll('source[data-src]');
    if (!lazySources.length) return;
    lazySources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.proofHydrated = 'true';
    video.load();
  };

  const openLightbox = async (trigger) => {
    const media = trigger.closest('[data-proof-media], .tan-story-card__media');
    const video = media?.querySelector('video');
    if (!media || !video) return;

    if (activeState) closeLightbox();
    ensureLightbox(trigger);
    hydrateVideo(video);

    const placeholder = document.createElement('span');
    placeholder.hidden = true;
    placeholder.setAttribute('aria-hidden', 'true');
    media.insertBefore(placeholder, video);

    const state = {
      trigger,
      media,
      video,
      placeholder,
      previousControls: video.controls,
      previousPreload: video.preload,
      previousBodyOverflow: document.body.style.overflow,
      onStateChange: undefined
    };
    state.onStateChange = () => emitState(state);
    activeState = state;

    video.addEventListener('playing', state.onStateChange);
    video.addEventListener('pause', state.onStateChange);
    video.addEventListener('ended', state.onStateChange);
    video.controls = true;
    video.preload = 'auto';
    video.classList.add('tan-reel-lightbox__video');
    stage.appendChild(video);

    lightbox.hidden = false;
    lightbox.removeAttribute('aria-hidden');
    document.body.classList.add('tan-reel-lightbox-open');
    document.body.style.overflow = 'hidden';
    emitState(state);
    closeButton.focus({ preventScroll: true });

    if (video.paused) {
      try {
        await video.play();
      } catch (error) {
        emitState(state);
      }
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-reel-expand]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openLightbox(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeState) closeLightbox();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (activeState?.media && (event.target === activeState.media || event.target.contains?.(activeState.media))) {
      closeLightbox();
    }
  });
})();
